import React from 'react'
import PaginationComponent from './../../../../../../components/pagination/pagination.component'
import { PartnerService } from '../../../../../../services/partner.service'

const Pagination = ({ params, paginationRef }) => (
	<PaginationComponent
		params={params}
		headers={headers}
		rowsPerPage={100}
		ref={paginationRef}
		sortable={sortable}
		renderRow={renderRow}
		getData={PartnerService.getTicketSalesReport}
	/>
)

const headers = [
	{
		header: 'Data da venda',
		key: 'saleDate',
		align: 'center'
	},
	{
		header: 'Data da Viagem',
		key: 'tripDate',
		align: 'center'
	},
	{
		header: 'Localizador',
		key: 'trackNumber'
	},
	{ header: 'Cliente', key: 'client' },
	{ header: 'Produto', key: 'product' },
	{ header: 'Passagem', key: 'value', align: 'center' },
	{ header: 'Total', key: 'totalValue', align: 'center' },
	{ header: 'Pontos', key: 'points', align: 'right' },
	{ header: 'Seguro', key: 'insuranceValue', align: 'right' },
	{ header: 'Resgate', key: 'redeemed' },
	{ header: 'Sit Pontos', key: 'pointsStatus' },
	{ header: 'Sit Passagem', key: 'ticketStatus' },
	{
		header: 'Data de cancelamento',
		key: 'cancelationDate',
		align: 'center'
	}
]

const sortable = {
	defaultOrder: 'desc',
	cols: [
		{ key: 'saleDate' },
		{ key: 'tripDate' },
		{ key: 'cancelationDate' },
		{ key: 'trackNumber' },
		{ key: 'client' },
		{ key: 'pointsStatus' },
		{ key: 'value' },
		{ key: 'insuranceValue' },
		{ key: 'points' },
		{ key: 'redeemed' }
	]
}

const renderRow = (rowData, headers) => {
	return headers.map(({ key, align }) => {
		if (key == 'value' || key == 'insuranceValue' || key == 'totalValue') rowData[key] = Number(rowData[key]).$toReais()

		return (
			<td key={key} align={align}>
				<span title={rowData[key]}>{rowData[key]}</span>
			</td>
		)
	})
}

export default Pagination
